export default __webpack_public_path__ + "static/media/joy_fix_service.0f1d72e3.svg";